import {Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {CodeView} from '../../Common/CodeView';
import Paper from '../../Common/Paper';
import Box from '../../Common/Box';
import Logger from "../../lib/Logger";
import {WebGLRenderer} from "three";

const logger = new Logger("WebGlInfo");

export default observer(function WebGlInfo(
        {
            renderers = [],
        }: {
            renderers: (WebGLRenderer)[],
        }) {

    const [refreshCount, setRefreshCount] = useState(0);

    useEffect(() => {

        if (renderers.length > 0) {
            logger.trace("refreshing timeout callback");
            const timeoutId = setTimeout(() => {
                logger.trace("refreshing");
                setRefreshCount(refreshCount + 1)
            }, 1000);
            return () => clearTimeout(timeoutId);
        }

    }, [setRefreshCount, refreshCount, renderers])

    return <Box
            style={{
                display: "flex",
                flexDirection: "column",
                padding: "14px",
                maxWidth: "100%",
                maxHeight: "100%",
                pointerEvents: "all",
            }}>
        {renderers.map((rendererInstance, i) => {

            if (rendererInstance instanceof WebGLRenderer) {
                const renderer = rendererInstance as WebGLRenderer;
                // @ts-ignore
                return <Paper
                        key={i}
                        sx={{overflow: "auto"}}
                        elevation={2}
                        column
                        padding={"12px"}
                        marginBottom={"12px"}
                >
                    {/*@ts-ignore*/}
                    <Box>{"Renderer id: " + renderer.id}</Box>
                    <Box>{"Refresh count: " + refreshCount}</Box>
                    <Typography variant={"overline"}>{"Memory"}</Typography>
                    {/*@ts-ignore*/}
                    <CodeView json={JSON.stringify(renderer.info.memory)}/>

                    <Typography variant={"overline"}>{"Render"}</Typography>
                    {/*@ts-ignore*/}
                    <CodeView json={JSON.stringify(renderer.info.render)}/>

                    <Typography variant={"overline"}>{"Programs"}</Typography>
                    {/*@ts-ignore*/}
                    <CodeView json={JSON.stringify(renderer.info.memory)}/>

                </Paper>
            } else {
                throw new Error("Unexpected renderer")
            }

        })
        }
    </Box>
});
